import apiService from "@/services/apiService";

export type PreferredAccountType = "PARTNER" | "COMMERCIAL";

const SETTING_KEY = "preferredAccountType";

const isPreferredAccountType = (
  value: unknown,
): value is PreferredAccountType => value === "PARTNER" || value === "COMMERCIAL";

export const preferredAccountTypeService = {
  async get(): Promise<PreferredAccountType | null> {
    const settings = await apiService.getMyAppSettings();
    const value = settings[SETTING_KEY];
    return isPreferredAccountType(value) ? value : null;
  },

  async set(value: PreferredAccountType): Promise<void> {
    await apiService.setMyAppSetting(SETTING_KEY, value);
  },
};